import script from "./OperatorTerminalConfigPC.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorTerminalConfigPC.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__